import React, { useState } from 'react';
import emailjs from '@emailjs/browser';
import ReCAPTCHA from "react-google-recaptcha";
//import emailjs, { EmailJSResponseStatus } from '@emailjs/nodejs';
import SimpleReactValidator from 'simple-react-validator';

const ContactForm = () => {
    const [forms, setForms] = useState({
        name: '',
        email: '',
        subject: '',
        phone: '',
        message: ''
    });

    const [validator] = useState(
        new SimpleReactValidator({
            className: 'errorMessage'
        })
    );

    const changeHandler = (e) => {
        setForms({ ...forms, [e.target.name]: e.target.value });
        validator.showMessages();
    };

    const [recaptchaValue, setRecaptchaValue] = useState(null);
    const [showForm, setShowForm] = useState(true);
    const [showSuccessMessage, setShowSuccessMessage] = useState(false);

    const handleRecaptchaChange = (value) => {
        setRecaptchaValue(value);
    };

    const submitHandler = async (e) => {
        e.preventDefault();

        if (!recaptchaValue) {
            // If reCAPTCHA is not verified, you can handle it accordingly
            console.error('Please verify reCAPTCHA');
            return;
        }

        if (validator.allValid()) {
            try {
                const templateParams = {
                    from_name: forms.name,
                    from_email: forms.email,
                    to_name: 'Abdul Cholik Studio', // Replace with your recipient's name
                    subject: forms.subject,
                    message: forms.message
                };

                await emailjs.send(
                    'service_l05mh24',
                    'template_7o5wtju',
                    templateParams,
                    '3BajXxRbVJwGd5942'
                );

                // Email sent successfully, do something (e.g., show success message)
                console.log('Email sent!');
                setShowForm(false);
                setShowSuccessMessage(true);
                
                // Clear form inputs after successful submission
                setForms({
                    name: '',
                    email: '',
                    subject: '',
                    phone: '',
                    message: ''
                });
            } catch (error) {
                // Handle error while sending email
                console.error('Email sending failed:', error);
            }
        } else {
            validator.showMessages();
        }
    };

    return (
        <div>
            {showForm && (
        <form method="post" className="contact-validation-active" onSubmit={(e) => submitHandler(e)} >
            <div className="row align-items-center">
                <div className="col-md-6 col-md-6 col-12">
                    <div className="form-group">
                        <label>Name*</label>
                        <input
                            value={forms.name}
                            type="text"
                            name="name"
                            onBlur={(e) => changeHandler(e)}
                            onChange={(e) => changeHandler(e)}
                            className="form-control"
                            placeholder="Your Name" />
                        {validator.message('name', forms.name, 'required|alpha_space')}
                    </div>
                </div>
                <div className="col-md-6 col-md-6 col-12">
                    <div className="form-group">
                        <label>Email*</label>
                        <input
                            value={forms.email}
                            type="email"
                            name="email"
                            onBlur={(e) => changeHandler(e)}
                            onChange={(e) => changeHandler(e)}
                            className="form-control"
                            placeholder="Your Email" />
                        {validator.message('email', forms.email, 'required|email')}
                    </div>
                </div>
                <div className="col-md-12">
                    <div className="fullwidth form-group">
                        <label>Message*</label>
                        <textarea
                            onBlur={(e) => changeHandler(e)}
                            onChange={(e) => changeHandler(e)}
                            value={forms.message}
                            type="text"
                            name="message"
                            className="form-control"
                            placeholder="Message">
                        </textarea>
                        {validator.message('message', forms.message, 'required')}
                    </div>
                </div>
                <div className="col-md-5 order-md-1 order-2 col-12">
                    <div className="submit-area" style={{ marginTop: '0'}}>
                        <ReCAPTCHA
                            sitekey="6LeJQ8oqAAAAAFVd1yjFAYzwz1LcMaZ6QYw9ntxN"
                            onChange={handleRecaptchaChange}
                            theme='dark'
                        />
                        <button type="submit" className="theme-btn" style={{ marginTop: '20px'}}>Submit now</button>
                        <div id="loader">
                            <i className="ti-reload"></i>
                        </div>
                    </div>
                </div>
            </div>
        </form>
        )}
        {showSuccessMessage && (
                <div>
                    <p style={{ textAlign: 'center'}}>Email sent successfully!</p>
                    {/* You can customize the success message as needed */}
                </div>
            )}
        </div>
    )
}

export default ContactForm;